export const convertToUrl = (country: string) =>
   country.split(' ').join('-').toLowerCase()
